export default "__VITE_ASSET__nN_lPpb___"